var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.173930031,4.97994878 C0.4394273,5.29794551 0.91192244,5.34144506 1.22991917,5.07594779 L4.49988553,2.35122582 L4.49988553,11.2498843 C4.49988553,11.66388 4.83588208,11.9998766 5.24987782,11.9998766 C5.66387356,11.9998766 5.99987011,11.66388 5.99987011,11.2498843 L5.99987011,2.35122582 L9.26983647,5.07594779 C9.58858319,5.34144506 10.0610783,5.29794551 10.3258256,4.97994878 C10.5913229,4.66195205 10.5485733,4.18870692 10.2298266,3.92395964 L5.72987288,0.17399821 C5.69462325,0.143998519 5.65262368,0.129748665 5.61362408,0.107248897 C5.5828744,0.089249082 5.55587467,0.068249298 5.52212502,0.0547494369 C5.43437592,0.0202497917 5.34287686,0 5.24987782,0 C5.15687878,0 5.06537972,0.0202497917 4.97763062,0.0547494369 C4.94388097,0.068249298 4.91688125,0.089249082 4.88613156,0.107248897 C4.84713196,0.129748665 4.8051324,0.143998519 4.76988276,0.17399821 L0.269929043,3.92395964 C-0.0480676861,4.18870692 -0.0915672387,4.66195205 0.173930031,4.97994878",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B8AB7E",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 13.5,
    x2: 10.5,
    y2: 13.5,
    id: "Line",
    stroke: "#19222F",
    fill: "#19222F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    transform: "translate(5.250000, 5.999938) scale(1, -1) translate(-5.250000, -5.999938) "
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#19222F",
    transform: "translate(5.250000, 5.999938) scale(1, -1) translate(-5.250000, -5.999938) ",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download-icon.c442cd4e1de91d041d95e0e410d50f76.svg";
export { ForwardRef as ReactComponent };